import { styled, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import brandclub_colors from '../../colors/brandclubColors.js';
import { FilterDialog } from './FilterDialog.js';
import { TuneIcon } from '../../icons/TuneIcon.js';

var SearchBarContainer = styled('div')({
    flex: 1,
    '@keyframes pulsate': {
        '0%': {
            opacity: 0,
        },
        '60%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    animation: 'pulsate 1s',
});
var FilterIcon = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: 22,
        width: 22,
        cursor: 'pointer',
        border: "1.5px solid",
        borderColor: '#00000000',
        borderRadius: 300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '.filter_dot': {
            position: 'absolute',
            backgroundColor: theme.palette.primary.main,
            height: 4,
            width: 4,
            borderRadius: 300,
            top: '-0.5px',
            right: '-0.5px',
            border: "1.5px solid ".concat(brandclub_colors.blueWhite),
            display: 'none',
        },
        '&.filtered': {
            borderColor: theme.palette.primary.main,
            '.filter_dot': {
                display: 'block',
            },
        },
    });
});
var convertSearchParamToFilterCount = function (searchParams) {
    var params = {};
    searchParams.forEach(function (value, key) {
        var decodedKey = decodeURIComponent(key);
        var decodedValue = decodeURIComponent(value);
        // This key is part of an array
        if (decodedKey.endsWith('[]')) {
            decodedKey = decodedKey.replace('[]', '');
            params[decodedKey] || (params[decodedKey] = []);
            params[decodedKey].push(decodedValue);
            // Just a regular parameter
        }
        else {
            params[decodedKey] = decodedValue;
        }
    });
    var count = 0;
    if (params.campaignTypes) {
        count += 1;
    }
    if (params.retailPrice) {
        count += 1;
    }
    if (params.retailerIds) {
        count += 1;
    }
    if (params.categoryIds) {
        count += 1;
    }
    if (params.subCategoryIds) {
        count += 1;
    }
    return count;
};
var SearchInput = function (_a) {
    var searchInput = _a.searchInput, setSearchInput = _a.setSearchInput, useNavigate = _a.useNavigate, useSearchParams = _a.useSearchParams, persistentQueryParams = _a.persistentQueryParams, pageContext = _a.pageContext, routePrefix = _a.routePrefix, brandEntity = _a.brandEntity, axios = _a.axios, filterDialogOpen = _a.filterDialogOpen, setFilterDialogOpen = _a.setFilterDialogOpen, filterCount = _a.filterCount, setFilterCount = _a.setFilterCount, onSubmit = _a.onSubmit, onClose = _a.onClose;
    // On press enter, navigate to search results page
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    useEffect(function () {
        var newFilterCount = convertSearchParamToFilterCount(searchParams);
        setFilterCount(newFilterCount);
    }, [searchParams]);
    return (React.createElement(SearchBarContainer, null,
        React.createElement(FilterDialog, { searchInput: searchInput, setSearchInput: setSearchInput, brandId: brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id, routePrefix: routePrefix, navigate: navigate, open: filterDialogOpen, onClose: function () { return setFilterDialogOpen(false); }, persistentQueryParams: persistentQueryParams, searchParams: searchParams, pageContext: pageContext, axios: axios, onCloseSearchDropdown: onClose }),
        React.createElement(TextField, { "aria-owns": "search-popover", "aria-haspopup": "true", id: "filled-adornment-weight", "aria-describedby": "filled-weight-helper-text", variant: "standard", placeholder: "Search products", value: searchInput, onKeyDown: function (e) {
                if (e.key === 'Enter') {
                    onClose();
                    onSubmit();
                }
            }, onChange: function (event) { return setSearchInput(event.target.value); }, 
            // inputProps={{ maxLength: 200 }}
            InputProps: {
                'aria-label': 'weight',
                autoComplete: 'off',
                disableUnderline: true,
                endAdornment: (React.createElement(FilterIcon, { className: filterCount ? 'filtered' : '', onClick: function () {
                        setFilterDialogOpen(true);
                    } },
                    React.createElement("div", { className: "filter_dot" }),
                    React.createElement(TuneIcon, { color: "primary", sx: { fontSize: 12 }, role: "button" }))),
            }, sx: function (theme) { return ({
                borderRadius: 17,
                //   border: `1px solid ${brandclub_colors.blueWhiteBorder}`,
                height: 38,
                width: '100%',
                backgroundColor: brandclub_colors.blueWhite,
                '& div.MuiInput-root': {
                    padding: '0 4px 0 14px',
                    display: 'flex',
                    alignItems: 'center',
                    height: 38,
                    '& input': {
                        padding: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        fontFamily: 'Poppins',
                        color: theme.palette.primary.main,
                    },
                },
            }); } })));
};

export { SearchInput as default };
//# sourceMappingURL=SearchBar.js.map
